import { mapDataSource, type RawDataSource } from '~/Api/DataSource';

import Status from './Status';

interface RawStatus {
	type: any;
	dataSource: RawDataSource;
	validFrom: string | null;
	retrievedAt: string | null;
	availableSince: string | null;
	nextEstimatedUpdate: string | null;
	lastUpdateAt: string;
}

export default function mapStatus(status: RawStatus): Status {
	return new Status(
		status.type,
		mapDataSource(status.dataSource),
		status.validFrom !== null ? new Date(status.validFrom) : null,
		status.retrievedAt !== null ? new Date(status.retrievedAt) : null,
		status.availableSince !== null ? new Date(status.availableSince) : null,
		status.nextEstimatedUpdate !== null ? new Date(status.nextEstimatedUpdate) : null,
		new Date(status.lastUpdateAt)
	);
}
